import React from 'react'

type Props = {
  className?: string
  fill: string
  size: string
}

const ClockCircle = ({ className, fill, size }: Props) => (
  <svg
    className={className}
    fill={fill}
    height={size}
    viewBox='0 0 34 34'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M16.9997 0.333374C7.83301 0.333374 0.333008 7.83337 0.333008 17C0.333008 26.1667 7.83301 33.6667 16.9997 33.6667C26.1663 33.6667 33.6663 26.1667 33.6663 17C33.6663 7.83337 26.1663 0.333374 16.9997 0.333374ZM23.9997 24L15.333 18.6667V8.66671H17.833V17.3334L25.333 21.8334L23.9997 24Z' />
  </svg>
)

export default ClockCircle
